<template>
  <div>
    <p v-if="msTime.show">
      <!--<span v-if="tipShow">{{tipText}}:</span>-->
      <!--<span v-if="!tipShow">{{tipTextEnd}}:</span>-->
      <span v-if="msTime.day>0">{{msTime.day}}</span><i>{{" "+dayTxt+" "}}</i>
      <span>{{msTime.hour}}</span><i>{{hourTxt}}</i>
      <span>{{msTime.minutes}}</span><i>{{minutesTxt}}</i>
      <span>{{msTime.seconds}}</span><i>{{secondsTxt}}</i>
    </p>
    <!--<p v-if="!msTime.show">{{endText}}</p>-->
  </div>
</template>
<script>
  export default {
    replace: true,
    data () {
      return {
        tipShow: true,
        msTime: {			//ค่านับถอยหลัง
          show: false,		//สถานะการนับถอยหลัง
          day: '',			//ฟ้า
          hour: '',		//ชั่วโมง
          minutes: '',		//นาที
          seconds: ''		//ที่สอง
        },
        star: '',			//เวลาเริ่มกิจกรรม
        end: '',				//เวลาสิ้นสุดกิจกรรม
        current: '',         //เวลาปัจจุบัน
      }
    },
    watch: {
      currentTime: function (val, oldval) {
        this.gogogo();
      }
    },
    props: {
      //ระยะทางเริ่มต้นด้วยข้อความพร้อมท์
      tipText: {
        type: String,
        default: 'ระยะทางเริ่มต้น'
      },
      //ข้อความแจ้งสิ้นสุดระยะทาง
      tipTextEnd: {
        type: String,
        default: 'สิ้นสุดระยะทาง'
      },
      //การควบคุมเวลาID
      id: {
        type: String,
        default: '1'
      },
      //เวลาปัจจุบัน
      currentTime: {
        type: Number
      },
      // เวลาเริ่มกิจกรรม
      startTime: {
        type: Number
      },
      // เวลาสิ้นสุดกิจกรรม
      endTime: {
        type: Number
      },
      // ข้อความจะแสดงเมื่อสิ้นสุดการนับถอยหลัง
      endText: {
        type: String,
        default: 'สิ้น สุด วันที่'
      },
      //ปรับแต่งข้อความที่แสดง:ฟ้า
      dayTxt: {
        type: String,
        default: ':'
      },
      //ปรับแต่งข้อความที่แสดง:เวลา
      hourTxt: {
        type: String,
        default: ':'
      },
      //ปรับแต่งข้อความที่แสดง:แบ่ง
      minutesTxt: {
        type: String,
        default: ':'
      },
      secondsTxt: {
        type: String,
        default: ':'
      },
      //จะเปิดการนับถอยหลังของนาฬิกาจับเวลาหรือไม่，ที่จะดําเนินการต่อ
      secondsFixed: {
        type: Boolean,
        default: false
      },
    },
    mounted () {
      console.log(this)
      this.gogogo();
    },
    methods: {
      gogogo: function () {
        //ตัดสินว่าเป็นวินาทีหรือมิลลิวินาที
        this.startTime.toString().length == 10 ? this.star = this.startTime * 1000 : this.star = this.startTime;
        this.endTime.toString().length == 10 ? this.end = this.endTime * 1000 : this.end = this.endTime;
        if (this.currentTime) {
          this.currentTime.toString().length == 10 ? this.current = this.currentTime * 1000 : this.current = this.currentTime;
        } else {
          this.current = ( new Date() ).getTime();
        }

        if (this.end < this.current) {
          /**
           * เวลาสิ้นสุดน้อยกว่าเวลาปัจจุบัน กิจกรรมได้สิ้นสุดลงแล้ว
           */
          this.msTime.show = false;
          this.end_message();
        }
        else if (this.current < this.star) {
          /**
           * เวลาปัจจุบันน้อยกว่าเวลาเริ่มต้น กิจกรรมยังไม่เริ่ม
           */
          this.$set(this, 'tipShow', true);
          setTimeout(() => {
            this.runTime(this.star, this.current, this.start_message);
          }, 1);
        }
        else if (this.end > this.current && this.star < this.current || this.star == this.current) {
          /**
           * เวลาสิ้นสุดมากกว่าเวลาปัจจุบันและเวลาเริ่มต้นน้อยกว่าเวลาปัจจุบัน，การนับถอยหลังสู่จุดเริ่มต้นของกิจกรรมการดําเนินการ
           */
          this.$set(this, 'tipShow', false);
          this.msTime.show = true;
          this.$emit('start_callback', this.msTime.show);
          setTimeout(() => {
            this.runTime(this.end, this.star, this.end_message, true)
          }, 1);
        }
      },
      runTime (startTime, endTime, callFun, type) {
        let msTime = this.msTime;
        let timeDistance = startTime - endTime;
        if (timeDistance > 0) {
          this.msTime.show = true;
          msTime.day = Math.floor(timeDistance / 86400000);
          timeDistance -= msTime.day * 86400000;
          msTime.hour = Math.floor(timeDistance / 3600000);
          timeDistance -= msTime.hour * 3600000;
          msTime.minutes = Math.floor(timeDistance / 60000);
          timeDistance -= msTime.minutes * 60000;
          //จะเปิดการนับถอยหลังของนาฬิกาจับเวลาหรือไม่,ที่จะดําเนินการต่อ
//                    this.secondsFixed ? msTime.seconds = new Number(timeDistance / 1000).toFixed(2) : msTime.seconds = Math.floor( timeDistance / 1000 ).toFixed(0);
          msTime.seconds = Math.floor(timeDistance / 1000).toFixed(0);
          timeDistance -= msTime.seconds * 1000;

          if (msTime.hour < 10) {
            msTime.hour = "0" + msTime.hour;
          }
          if (msTime.minutes < 10) {
            msTime.minutes = "0" + msTime.minutes;
          }
          if (msTime.seconds < 10) {
            msTime.seconds = "0" + msTime.seconds;
          }
          let _s = Date.now();
          let _e = Date.now();
          let diffPerFunc = _e - _s;
          setTimeout(() => {
            if (type) {
              this.runTime(this.end, endTime += 1000, callFun, true);
            } else {
              this.runTime(this.star, endTime += 1000, callFun);
            }
          }, 1000 - diffPerFunc)
        }
        else {
          callFun();
        }
      },
      start_message () {
        this.$set(this, 'tipShow', false);
        this.$emit('start_callback', this.msTime.show);
        setTimeout(() => {
          this.runTime(this.end, this.star, this.end_message, true)
        }, 1);
      },
      end_message(){
        this.msTime.show = false;
        if (this.currentTime <= 0) {
          return;
        }
        this.$emit('end_callback', this.msTime.show);
      }
    }
  }
</script>
